import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { Box, Button } from '@mui/material';
import WarningIcon from '../../icons/WarningIcon';
import { palette } from '../../../theme';

const InfoDialog = ({ open, onClose, title, children, isWarning = false }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle style={{ textAlign: 'center' }}>
      <Box display="flex" alignItems="center" justifyContent="center">
        {isWarning && <WarningIcon w="1.75rem" h="1.75rem" color={palette.error.main} />}
        {title}
      </Box>
    </DialogTitle>
    <DialogContent>
      <DialogContentText>{children}</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button variant="contained" color="primary" padding="20px" onClick={onClose}>
        Ok
      </Button>
    </DialogActions>
  </Dialog>
);

InfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  isWarning: PropTypes.bool,
};

InfoDialog.defaultProps = {
  isWarning: false,
};

export default InfoDialog;
